'use client'

import React, { useContext } from 'react'
import { HotelPageContext } from '@/components/hotel/HotelPageContext'

export function ProgramFeatures(props: { programCode: string }) {
  const { getProgram } = useContext(HotelPageContext)

  const program = getProgram(props.programCode)

  return (
    <div className="truncate text-sm leading-tight text-stone-800 open:hidden">
      {program.features}
    </div>
  )
}
